module.exports = __webpack_public_path__ + "static/americanah-f2ed1fc1b6a40fd9b6a7b1f41fe93ddb.jpg";